<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-22T23:19:46+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2018-10-26T17:37:36+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <div id="app">
    <span id="landing" />
    <navbar />
    <main>
      <router-view />
    </main>
  </div>
</template>

<script>
// import vue
import Vue from 'vue'
// sub components we need in all/most pages
import Navbar from '@/components/navigation/Navbar'
import NavBottom from '@/components/navigation/NavBottom'
import ResponseForm from '@/lib/modules/_responseform'
import DefaultPage from '@/lib/modules/_page'
import LocSwitcher from '@/assets/lang/_locale-switcher'

// https://rigor789.github.io/vue-scrollto/#/
import VueScrollTo from 'vue-scrollto'

// smooth scrolling in singple page app - page
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -80,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

// register
Vue.component('navbar', Navbar)
Vue.component('navbottom', NavBottom)
Vue.component('responseform', ResponseForm)
Vue.component('page', DefaultPage)
Vue.component('locale-switcher', LocSwitcher)

export default {
  name: 'App'
}

</script>

<style lang="scss">

  @import "assets/style/theme.scss";
  @import "assets/style/extras.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

  #update-alert {
    top: 66px;
    position: absolute;
    padding-right: 50px;
  }

  main {
    margin-top: 80px;
  }

</style>
